import { RouterOutlet } from '@angular/router';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { AppOverlaysComponent } from '@shared/components/app-overlays/app-overlays.component';
import { ThemeStore } from '@shared/stores/theme/theme.store';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppOverlaysComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  protected readonly title = signal('portal_admin_ng_dev_pri_usw2');

  constructor() {
    inject(ThemeStore).initializeTheme();
  }
}
